import '../css/CheckResume.css';
import { useLocation } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import '../css/pagination.css'
import { Properties,Endpoint,systemConfiguration,getDecryptedValueByProperty,getHeaders, fetchOperation ,handleEncode} from '../../CommonImports';
import {useState,useEffect } from '../../InBuildImports';




const CheckResume = () => {
      const token = getDecryptedValueByProperty(Properties.SESSION_TOKEN_PROP);
  
  const [bordingEmployee, setBordingEmployee] = useState([]);
  const [filteredBoardingEmployee, setfilteredBoardingEmployee] = useState([]);

  const search = useLocation().search;
  const securityKeyValue = new URLSearchParams(search).get(Properties.SECURITY_KEY_PROP);
  const studentId = getDecryptedValueByProperty(Properties.STUDENT_ID_PROP);
  const [filterBy, setfilterBy] = useState('All');
  const [filtervalue, setfiltervalue] = useState('');

   const Header_Json=getHeaders(token,handleEncode(studentId))

  useEffect(() => {
    const fetchData = async (securityKeyValue) => {
     
      const url=`${systemConfiguration.HOST}${Endpoint.GET_ALL_RESUMES_DATA}` + securityKeyValue
        const response = await fetchOperation(url,Header_Json);
        setBordingEmployee(response);
        setfilteredBoardingEmployee(response);
      
    };

    fetchData(securityKeyValue);
  }, [securityKeyValue]);


  useEffect(() => {
    if (filterBy === 'All' || filtervalue === '') {
      setfilteredBoardingEmployee(bordingEmployee);
    } else {
      const result = bordingEmployee.filter((user) => {
        if (filterBy === 'role') {
          return user.role.toLowerCase() === filtervalue.toLowerCase();
        } else if (filterBy === 'Experience') {
          return user.totalExperience == filtervalue;
        } else if (filterBy === 'skills') {
          const selectedSkills = filtervalue.split(',');
          const singleData = selectedSkills[0];
          return user.skills.toLowerCase().includes(singleData.toLowerCase());

        } else {
          return true;
        }
      });
      setfilteredBoardingEmployee(result);
    }
  }, [filterBy, filtervalue, bordingEmployee]);


  const formatTextWithLineBreaks = (text) => {
    return text.length > 30 ? text.match(/.{1,40}/g).join("\n") : text;
  };


  const uniqueValues = (key) => {
    return [...new Set(bordingEmployee.map((user) => user[key]))]
  };

  const uniqueValuesforSkills = (key) => {
    return [...new Set(bordingEmployee.map((user) => user[key].split(',')[0].toLowerCase()))]
  };


  const getsecondDropDown = () => {

    if (filterBy === 'role') {
      return uniqueValues('role');
    }
    else if (filterBy === 'Experience') {
      return uniqueValues('totalExperience');
    }
    else if (filterBy === 'skills') {
      return uniqueValuesforSkills('skills');
    }
    else {
      return [];
    }
  }

  const [pageNumber, setpageNumber] = useState(0)

  const usersPerPage = 10
  const pagesVisited = pageNumber * usersPerPage;


  const pageCount = Math.ceil(filteredBoardingEmployee.length / usersPerPage)

  const changePage = ({ selected }) => {
    setpageNumber(selected)
  }



  return (

    <div className="Grcommon-form">
      <h4 className='Grstyle'>Upload Resume List</h4>
      {/*First dropdown */}
      <div className="filter-update-container">
        <label className='Grstyle'>Filter :</label>
        <select
          value={filterBy}
          onChange={(e) => {
            setfilterBy(e.target.value);
            setfiltervalue('')
          }}
        >
          <option value='All'>All</option>
          <option value='role'>role</option>
          <option value='Experience'>Experience</option>
          <option value='skills'>skills</option>

        </select>
      </div>


      {/*Second dropdown */}

      {filterBy !== 'All' && (
        <div className="filter-update-container">
          <label className='Grstyle'>Filter by {filterBy} :</label>
          <select
            value={filtervalue}
            onChange={e => setfiltervalue(e.target.value)}
          >
            <option value=''>----Select----</option>
            {getsecondDropDown().map((data, index) => (
              <option key={index} value={data}>{data}</option>
            ))}
          </select>
        </div>
      )}

      <table className="Grcommon-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>fullName</th>
            <th>phoneNo</th>
            <th>emailId</th>
            <th>skills</th>
            <th>role</th>
            <th>Experience</th>
            <th>resumeUrl</th>

          </tr>
        </thead>
        <tbody>
          {filteredBoardingEmployee.slice(pagesVisited, pagesVisited + usersPerPage).map((employee, index) => (
            <tr key={index}   >
              <td>
                {
                  employee.creationTime
                }
              </td>
              <td>
                {
                  employee.fullName
                }
              </td>
              <td>
                {
                  employee.phoneNo
                }
              </td>
              <td>
                {
                  employee.emailId
                }
              </td>
              <td>
                {
                  employee.skills
                }
              </td>
              <td>
                {
                  employee.role
                }
              </td>
              <td>
                {
                  employee.totalExperience
                }
              </td>
              <td>
                {
                  <a href={formatTextWithLineBreaks(employee.resumeUrl + "?" + systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN)} target="_blank" rel="noopener noreferrer">DownLoad Resume</a>
                }
              </td>
            </tr>


          ))}
        </tbody>
      </table>

      <ReactPaginate
        previousLabel={"<"}
        nextLabel={">"}
        pageCount={pageCount}
        onPageChange={changePage}
        containerClassName={"paginationBttns"}
        previousLinkClassName={"previousBttns"}
        nextLinkClassName={"nextBttn"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}
      />
    </div>

  );
};

export default CheckResume;
